angular.module('impactx.util').filter('encodeUri', function() {
    return function(value) {
        return encodeURIComponent(value);
    };
});
